(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fc-collection-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('.fc-collection-products');

    sections.forEach(function(section) {
      var tabs = section.querySelectorAll('.fc-collection-products__tab');
      var grid = section.querySelector('.fc-collection-products__grid');

      if (!tabs.length || !grid) return;

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          var view = this.getAttribute('data-tab');

          tabs.forEach(function(t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-pressed', 'false');
          });

          this.classList.add('is-active');
          this.setAttribute('aria-pressed', 'true');
          grid.setAttribute('data-view', view);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-lens-works-graph"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('.fc-lens-works-graph');

    sections.forEach(function(section) {
      var checkbox = section.querySelector('.fc-lens-works-graph__checkbox');
      var container = section.querySelector('.fc-lens-works-graph__graph-container');

      if (!checkbox || !container) return;

      checkbox.addEventListener('change', function() {
        if (this.checked) {
          container.classList.remove('is-toggled');
        } else {
          container.classList.add('is-toggled');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-product-tab-details"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.fc-tab-details').forEach(function(section) {
    var tabs = section.querySelectorAll('.fc-tab-details__tab');
    var panels = section.querySelectorAll('.fc-tab-details__panel');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var index = this.getAttribute('data-fc-tab-index');

        tabs.forEach(function(t) {
          t.classList.remove('fc-tab-details__tab--active');
          t.setAttribute('aria-selected', 'false');
        });

        panels.forEach(function(p) {
          p.classList.remove('fc-tab-details__panel--active');
          p.setAttribute('hidden', '');
        });

        this.classList.add('fc-tab-details__tab--active');
        this.setAttribute('aria-selected', 'true');

        var activePanel = section.querySelector('[data-fc-panel-index="' + index + '"]');
        if (activePanel) {
          activePanel.classList.add('fc-tab-details__panel--active');
          activePanel.removeAttribute('hidden');
        }
      });

      tab.addEventListener('keydown', function(e) {
        var currentIndex = parseInt(this.getAttribute('data-fc-tab-index'));
        var newIndex;

        if (e.key === 'ArrowRight') {
          newIndex = (currentIndex + 1) % tabs.length;
        } else if (e.key === 'ArrowLeft') {
          newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        } else {
          return;
        }

        e.preventDefault();
        tabs[newIndex].click();
        tabs[newIndex].focus();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-science-section-2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sectionEl = document.querySelector('.fc-sci2');
    if (!sectionEl) return;

    var navItems = sectionEl.querySelectorAll('.fc-sci2__nav-item');

    navItems.forEach(function (item) {
      item.addEventListener('click', function (e) {
        var href = this.getAttribute('href');
        if (!href) return;

        var hash = '';

        if (href.charAt(0) === '#') {
          hash = href;
        } else {
          try {
            var url = new URL(href, window.location.origin);
            if (url.pathname === window.location.pathname && url.hash) {
              hash = url.hash;
            }
          } catch (err) {
            return;
          }
        }

        if (!hash) return;

        var target = document.querySelector(hash);
        if (!target) return;

        e.preventDefault();

        var headerOffset = 80;
        var top = target.getBoundingClientRect().top + window.scrollY - headerOffset;

        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-science-section-4"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.fc-sci4');

    sections.forEach(function (section) {
      var tabs = section.querySelectorAll('[data-fc-sci4-tab]');

      var isAnimating = false;

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          if (isAnimating) return;

          var panelId = tab.getAttribute('aria-controls');
          var allTabs = section.querySelectorAll('[data-fc-sci4-tab]');
          var activePanel = section.querySelector('.fc-sci4__panel--active');
          var nextPanel = document.getElementById(panelId);

          if (!nextPanel || activePanel === nextPanel) return;

          isAnimating = true;

          /* Update tab states immediately */
          allTabs.forEach(function (t) {
            t.classList.remove('fc-sci4__tab--active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('fc-sci4__tab--active');
          tab.setAttribute('aria-selected', 'true');

          /* Fade out current panel */
          activePanel.classList.remove('fc-sci4__panel--active');
          activePanel.classList.add('fc-sci4__panel--fading-out');

          activePanel.addEventListener('transitionend', function handleFadeOut(e) {
            if (e.propertyName !== 'opacity') return;
            activePanel.removeEventListener('transitionend', handleFadeOut);
            activePanel.classList.remove('fc-sci4__panel--fading-out');
            activePanel.setAttribute('hidden', '');

            /* Fade in next panel */
            nextPanel.removeAttribute('hidden');
            nextPanel.classList.add('fc-sci4__panel--fading-in');

            /* Force reflow so the browser registers opacity: 0 before transitioning to 1 */
            void nextPanel.offsetHeight;

            nextPanel.classList.add('fc-sci4__panel--active');
            nextPanel.classList.remove('fc-sci4__panel--fading-in');

            nextPanel.addEventListener('transitionend', function handleFadeIn(e) {
              if (e.propertyName !== 'opacity') return;
              nextPanel.removeEventListener('transitionend', handleFadeIn);
              isAnimating = false;
            });
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class FcMegaMenu extends HTMLElement {
    constructor() {
      super();
      this.triggers = [];
      this.closeBtn = this.querySelector('.fc-mega-menu__close');
      this.overlay = null;
    }

    connectedCallback() {
      const targetHandle = this.dataset.megaMenu;

      this.triggers = document.querySelectorAll(
        `[data-mega-menu-target="${targetHandle}"]`
      );

      this.headerWrapper = this.closest('.header-wrapper');

      this.overlay = document.createElement('div');
      this.overlay.classList.add('fc-mega-menu__overlay');
      document.body.appendChild(this.overlay);

      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', this.handleTriggerClick.bind(this));
      });

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', this.close.bind(this));
      }

      this.overlay.addEventListener('click', this.close.bind(this));

      this.handleKeydown = this.handleKeydown.bind(this);
      document.addEventListener('keydown', this.handleKeydown);
    }

    handleTriggerClick(e) {
      e.preventDefault();
      this.toggle();
    }

    handleKeydown(e) {
      if (e.key === 'Escape' && this.classList.contains('is-open')) {
        this.close();
      }
    }

    toggle() {
      if (this.classList.contains('is-open')) {
        this.close();
      } else {
        this.closeAllMegaMenus();
        this.open();
      }
    }

    open() {
      this.classList.add('is-open');
      this.overlay.classList.add('is-visible');
      this.headerWrapper.classList.add('fc-mega-menu--active');
      this.triggers.forEach((t) => t.setAttribute('aria-expanded', 'true'));
    }

    close() {
      this.classList.remove('is-open');
      this.overlay.classList.remove('is-visible');
      this.headerWrapper.classList.remove('fc-mega-menu--active');
      this.triggers.forEach((t) => {
        t.setAttribute('aria-expanded', 'false');
      });
    }

    closeAllMegaMenus() {
      document.querySelectorAll('fc-mega-menu.is-open').forEach((menu) => {
        if (menu !== this) menu.close();
      });
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.handleKeydown);
      if (this.overlay) this.overlay.remove();
    }
  }

  customElements.define('fc-mega-menu', FcMegaMenu);

  // Drawer mega menu toggle (mobile)
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-drawer-mega-toggle]');
    if (toggle) {
      e.preventDefault();
      const handle = toggle.dataset.drawerMegaToggle;
      const content = document.getElementById(`FcMegaMenuDrawer-${handle}`);
      if (!content) return;

      const isOpen = !content.hidden;

      document.querySelectorAll('.fc-mega-menu-drawer').forEach((el) => {
        el.hidden = true;
      });
      document.querySelectorAll('[data-drawer-mega-toggle]').forEach((t) => {
        t.setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        content.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    const closeBtn = e.target.closest('[data-mega-menu-drawer-close]');
    if (closeBtn) {
      const drawer = closeBtn.closest('.fc-mega-menu-drawer');
      if (drawer) {
        drawer.hidden = true;
        const handle = drawer.dataset.megaMenuDrawer;
        const btn = document.querySelector(
          `[data-drawer-mega-toggle="${handle}"]`
        );
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
